<template>
  <div class="password-validator">
    <!-- 验证用户历史密码是否符合规范 -->
    <a-modal
      :visible="dialogVisible"
      :title="$t('modifyPassword.title1')"
      :maskClosable="false"
      :keyboard="false"
      width="550px"
      centered
      :footer="null"
      :closable="false"
    >
      <div class="notice-content">
        <div class="notice-text">
          {{ $t('modifyPassword.password_simple') }}
        </div>
      </div>
      <div class="dialog-footer">
        <a-button @click="handleLogout" plain>{{ $t('layout.logout') }}</a-button>
        <a-button type="primary" @click="handleChangePassword">{{ $t('modifyPassword.title') }}</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { clearLoginInfo } from '@/utils/utils'
import Cookies from 'js-cookie'
/**
 * 密码验证弹窗组件
 * 用于提示用户密码过于简单，存在安全风险，需要修改密码
 */
export default {
  name: 'PasswordValidator',
  data() {
    return {
      dialogVisible: false,
    }
  },

  methods: {
    // 显示密码修改对话框
    handleOpen() {
      this.dialogVisible = true
    },
    // 处理修改密码按钮点击
    handleChangePassword() {
      this.dialogVisible = false
      this.updatePasswordHandle()
    },
    // 退出登录
    async handleLogout() {
      this.$g.clearLocalStorage()
      await this.$http('logout')
      clearLoginInfo()
      this.$g.returnLogin()
    },
    // 修改密码
    updatePasswordHandle() {
      this.$router.push({ path: '/user/password' })
    },

    // 关闭弹窗
    handleClose() {
      // 判断密码是否符合要求
      if (Cookies.get('isPasswordValid') == 'false') {
        this.handleOpen()
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  .ant-modal-content {
    border-radius: 4px;
    .ant-modal-header {
      padding: 15px 20px;
      border-bottom: 1px solid #ebeef5;
      .ant-modal-title {
        font-size: 16px !important;
        font-weight: bold !important;
      }
    }
    .ant-modal-body {
      padding: 30px 20px 20px;
      .notice-content {
        text-align: center;
        margin-bottom: 20px;
        .notice-text {
          color: #636666 !important;
          font-size: 14px !important;
          line-height: 1.6 !important;
          padding: 0 15px;
          white-space: normal;
          word-break: normal;
          display: inline-block;
          text-align: center;
          max-width: 100%;
        }
      }
      .dialog-footer {
        text-align: center;
        margin-top: 30px;
        .ant-btn {
          min-width: 120px;
          margin: 0 10px;
        }
      }
    }
    .ant-modal-close {
      top: 15px;
    }
  }
}
</style>
